const drawerStyles = {
  "& .MuiDrawer-paper": {
    background: "#0D0D0D",
    borderRight: "1px solid rgba(255,255,255,0.06)",
    boxShadow: "none",
  },
};

export const sidebarStyles = {
  drawerStyles: drawerStyles,
};
